module.exports = __webpack_public_path__ + "img/payment-success.c014f6e9.svg";